module.exports = __webpack_public_path__ + "img/数据治理_04.20b14951.svg";